import React from 'react';
import { Badge as Badge$1, Box } from '@chakra-ui/react';
import { BadgeVariant } from './types.js';
import { Typography } from '../Typography/component.js';
import { Icon } from '../Icon/component.js';
var Badge = function Badge(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === undefined ? BadgeVariant.subtle : _ref$variant,
    _ref$colorScheme = _ref.colorScheme,
    colorScheme = _ref$colorScheme === undefined ? 'gray' : _ref$colorScheme,
    textStyle = _ref.textStyle,
    icon = _ref.icon,
    children = _ref.children,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(Badge$1, {
    "data-object-type": "badge",
    variant: variant,
    colorScheme: colorScheme,
    pb: 0.5,
    pt: 0.5,
    pr: 1.5,
    pl: 1.5,
    size: size
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: textStyle
  }, !!icon && !!icon.iconName && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    display: "inline-block",
    pr: 1
  }, /*#__PURE__*/React.createElement(Icon, icon)), children));
};
Badge.displayName = "Badge";
export { Badge };